module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark@2x-07bff6f2be7cff216decac89b72cd098.png";